import { Link, useLocation } from 'react-router-dom';
import { categories, comics } from '@/mocks/comics';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const getBreadcrumbs = (): BreadcrumbItem[] => {
    const items: BreadcrumbItem[] = [{ label: '首页', path: '/' }];

    if (pathSegments.length === 0) return items;

    if (pathSegments[0] === 'category' && pathSegments[1]) {
      const cat = categories.find((c) => c.slug === pathSegments[1]);
      items.push({ label: cat ? `${cat.name}漫画` : '分类', path: `/category/${pathSegments[1]}` });
    }

    if (pathSegments[0] === 'article' && pathSegments[1]) {
      const comic = comics.find((c) => c.id === pathSegments[1]);
      if (comic) {
        const cat = categories.find((c) => c.slug === comic.category);
        items.push({ label: cat ? `${cat.name}漫画` : '分类', path: `/category/${comic.category}` });
        items.push({ label: comic.title });
      }
    }

    if (pathSegments[0] === 'about') {
      items.push({ label: '关于我们' });
    }

    return items;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3 bg-background-50 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto">
        <ol className="flex items-center gap-1.5 text-sm flex-wrap">
          {breadcrumbs.map((item, index) => (
            <li key={index} className="flex items-center gap-1.5">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              )}
              {item.path && index < breadcrumbs.length - 1 ? (
                <Link
                  to={item.path}
                  className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={index === breadcrumbs.length - 1 ? 'text-foreground-900 font-medium' : 'text-foreground-500'}>
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}